const camelizeSnakeCase = string =>
  string
    ? string
        .toString()
        .toLowerCase()
        .replace(/(_\w)/g, m => m[1].toUpperCase())
    : '';

export default camelizeSnakeCase;
